
import { Component, Vue, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { setSawVideoTutorial } from "../../utils/VideoTutorialUtil";

@Component
export default class UserManual extends Vue {
  private player: any;
  private visible = true;
  mounted() {
    this.player = this.$refs.videoPlayer as any;
  }

  @Emit("closeTerms")
  close() {
    setSawVideoTutorial(true);
    this.player.pause();
    return false;
  }

  play() {
    this.player.play();
  }

  public setVisible(isVisible: boolean) {
    this.visible = isVisible;
  }
}
